// Vendor-neutral browser error reporting. Call reportError() for errors you catch and don't rethrow;
// uncaught errors and unhandled promise rejections are captured by the tracker SDK itself
// (app/javascript/rollbar.js). To switch tracker, change only this adapter and that SDK setup.
export function reportError (message, error, context = {}) {
  try {
    const tracker = window.Rollbar

    if (tracker?.error) {
      tracker.error(message, error, context)
      return
    }
  } catch (_reportingError) {
    // Reporting must never break the page.
  }

  console.error(message, error)
}
